var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('acgn-statistic-detail',{attrs:{"comicId":_vm.comicId,"userId":_vm.userId,"onlyOverdue":true,"exportCode":"6005","isShowModify":true}})}
var staticRenderFns = []

export { render, staticRenderFns }